// extracted by css-extract-rspack-plugin
export default {"group":"v_oyIC1I7V8lkLXk"};